export default __webpack_public_path__ + "d1fbdad16cf2ded8e27dc41eb032c934.png";